import React, { Dispatch, SetStateAction } from 'react';

export interface AuthUser {
  firstName: string;
  emailId: string;
  uid: number;
}

export interface AuthContextInterface {
  user: AuthUser | null;
  setUser: Dispatch<SetStateAction<AuthUser | null>>;
}

const AuthContext = React.createContext<AuthContextInterface>({
  user: null,
  setUser: () => null,
});

export default AuthContext;
